import React from 'react';

function Error() {
  return (
    <div>
      <h3 className='text-center text-3xl m-10'>
        Whoops! There's no page here.
      </h3>
    </div>
  );
}

export default Error;
